import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { ApprovalsReqDto, ArticleTextileType, BuyerStatusReq, CKMeasurementLabelHangtagReq, CKMeasurementStatusDeleteBlockReq, CkMeasurementDataThreadsReq, CommonResponseModel, ImageUplaodReq, MeasurementDataCardDeleteReq, MeasurementDataReq, ReferenceFeatureEnum, StatusApprovalsEnum, StyleStautsReq, TrimCardStatusEnum, TrimCardUpdateReq, UnitSevenStatusEnum, UnitTwelevePdfReq, WFXAndVersionsIdReqDto, WFXIdReqDto, WFXRolesEnum, WFXStatusEnum, WfxCarharttEnum } from "@project-management-system/shared-models";
import axios from "axios";
import * as FormData from 'form-data';
import * as fs from 'fs';
import { join } from "path";
import { DataSource, In, Not, Repository } from "typeorm";
import * as XLSX from 'xlsx';
import { GenericTransactionManager } from "../../typeorm-transactions";
import { BuyerEntity } from "./dto/buyer-entity";
import { MeasurementDataShahiCarharttEntity } from "./dto/color-carhartt.entity";
import { WfxImageUploadEntity } from "./dto/file-upload-entity";
import { FolderImageUploadEntity } from "./dto/folder-image-upload-entity";
import { MeasurementDataEntity } from "./dto/measurement-data-entity";
import { ParameterEntity } from "./dto/parameter-entity";
import { StylesEntity } from "./dto/style-carhartt.entity";
import { StylesDto } from "./dto/styles-dto";
import { UnitTweleveExcelDataEntity } from "./dto/unit-twelve-excel.entity";
import { UnitTwelevFileUploadEntity } from "./dto/unit-twleve-file.entity";
import { WfxFileUploadEntity } from "./dto/wfx-file.entity";
import { WFXStatusWiseReqDto } from "./dto/wfx-status-wise-req.dto";
import { ApparelArticleMasterVersions } from "./entities/tech-pack-versions/apparel-article-masters-versions.entity";
import { FabricTrimsMasterVersions } from "./entities/tech-pack-versions/fabric-trims-master-versions.entity";
import { MeasurementChart2TVersions } from "./entities/tech-pack-versions/measurement-chart-2t-versions.entity";
import { MeasurementChartMonthsVersions } from "./entities/tech-pack-versions/measurement-chart-6-12-months-versions.entity";
import { ApparelArticleMaster } from "./entities/tech-pack/apparel-article-master.entity";
import { FabricTrimsMaster } from "./entities/tech-pack/fabric-trims-master.entity";
import { MeasurementChart2T } from "./entities/tech-pack/measurement-chart-2t.entity";
import { MeasurementChartMonths } from "./entities/tech-pack/measurement-chart-6-12-months.entity";
import { ApparelArticleMasterRepo } from "./repositories/apparel-article-master.repo";
import { BuyerRepo } from "./repositories/buyer-repo";
import { ColorCarharttRepository } from "./repositories/color-carhartt-repo";
import { FabricTrimsMasterRepo } from "./repositories/fabric-trims-master.repo";
import { FolderUploadRepository } from "./repositories/folder-image-upload-repo";
import { ImagesRepo } from "./repositories/images-repo";
import { ParameterRepo } from "./repositories/parameter-repo";
import { StyleRepo } from "./repositories/style-repo";
import { UnitTweleveExcelRepo } from "./repositories/unit-tweleve-excel-repo";
import { UnitTwelveRepo } from "./repositories/unit-twleve-repo";
import { ApparelArticleMasterVersionsRepo } from "./repositories/versions-repos/apparel-article-master.repo";
import { WfxRepository } from "./repositories/wfx-file-repo";
import { WFXAdapter } from "./wfx-adapter";
import { MeasurementDataDTO } from "./dto/measurement-dto";
@Injectable()
export class WfxService {
  constructor(
    private WfxFileRepo: WfxRepository,
    private ColorCarharttRepo: ColorCarharttRepository,

    @InjectRepository(WfxImageUploadEntity)
    private fileRepo: Repository<WfxImageUploadEntity>,

    @InjectRepository(MeasurementDataEntity)
    private measurementRepo: Repository<MeasurementDataEntity>,

    private styleRepo: StyleRepo,
    private dataSource: DataSource,
    private buyerRepo: BuyerRepo,
    private parameterRepo: ParameterRepo,
    private imagesRepo: ImagesRepo,
    private unitTwelveRepo: UnitTwelveRepo,
    private unittweleveexcelRepo: UnitTweleveExcelRepo,
    private apparelAMrepo: ApparelArticleMasterRepo,
    private fabricTrimsMasterRepo: FabricTrimsMasterRepo,
    private WFXAdapter: WFXAdapter,
    private versionsApparelRepo: ApparelArticleMasterVersionsRepo,
    private folderUploadRepo: FolderUploadRepository,
  ) { }


  async multipleFileUploads(files: Express.Multer.File[]): Promise<CommonResponseModel> {
    let extractedData: any;
    try {
      for (const file of files) {
        console.log(file, "service file");
        const formData = new FormData();
        const fileToUpload = file.buffer ? file.buffer : fs.readFileSync(file.path);
        const fileName = file.originalname;
        formData.append('file', fileToUpload, { filename: fileName });
        // const downloadUrl = 'http://192.168.1.104:2000/extract-tables';
        const downloadUrl = 'http://165.22.220.143:2000/upload';
        const firstResponse = await axios.post(downloadUrl, formData, {
          headers: {
            ...formData.getHeaders(),
          },
          responseType: 'arraybuffer',
        });

        console.log(firstResponse.data, "firstResponse data");
        const data = new Uint8Array(firstResponse.data);
        console.log(data, "data");
        const workbook = XLSX.read(data, { type: 'array' });
        console.log(workbook, "workbook");
        const sheetName = workbook.SheetNames[0];
        console.log(sheetName, "sheetName");
        const sheet = workbook.Sheets[sheetName];
        console.log(sheet, "sheet");
        const jsonSheet = XLSX.utils.sheet_to_json(sheet, { defval: null, raw: false });
        console.log(jsonSheet, "jsonSheet");
        const extractedExcelData = jsonSheet.filter(row => Object.values(row).some(cell => cell !== null && cell !== ''));
        console.log(extractedExcelData, "extractedExcelData");
        extractedData = extractedExcelData.flat()
      }
      return new CommonResponseModel(true, 1234, 'Data Extracted', extractedData);
    } catch (error) {
      console.error('Error during file upload and processing:', error);
      throw new Error('Failed to upload and process the files');
    }
  }

  // async multipleFileUploadsCK(files: Express.Multer.File[]): Promise<CommonResponseModel> {
  //   let extractedData: any;
  //   try {
  //     for (const file of files) {
  //       console.log(file, "service file");
  //       const formData = new FormData();
  //       const fileToUpload = file.buffer ? file.buffer : fs.readFileSync(file.path);
  //       const fileName = file.originalname;
  //       formData.append('file', fileToUpload, { filename: fileName });
  //       const downloadUrl = 'http://192.168.1.100:2000/extract-tables';
  //       const firstResponse = await axios.post(downloadUrl, formData, {
  //         headers: {
  //           ...formData.getHeaders(),
  //         },
  //         responseType: 'arraybuffer',
  //       });

  //       console.log(firstResponse.data, "firstResponse data");
  //       const data = new Uint8Array(firstResponse.data);
  //       console.log(data, "data");
  //       const workbook = XLSX.read(data, { type: 'array' });
  //       console.log(workbook, "workbook");
  //       const sheetName = workbook.SheetNames[0];
  //       console.log(sheetName, "sheetName");
  //       const sheet = workbook.Sheets[sheetName];
  //       console.log(sheet, "sheet");
  //       const jsonSheet = XLSX.utils.sheet_to_json(sheet, { defval: null, raw: false });
  //       console.log(jsonSheet, "jsonSheet");
  //       const extractedExcelData = jsonSheet.filter(row => Object.values(row).some(cell => cell !== null && cell !== ''));
  //       console.log(extractedExcelData, "extractedExcelData");
  //       extractedData = extractedExcelData.flat()
  //     }
  //     return new CommonResponseModel(true, 1234, 'Data Extracted', extractedData);
  //   } catch (error) {
  //     console.error('Error during file upload and processing:', error);
  //     throw new Error('Failed to upload and process the files');
  //   }
  // }

  async multipleFileUploadsCK(files: Express.Multer.File[]): Promise<CommonResponseModel> {
    let extractedData: any;
    try {
      for (const file of files) {
        const formData = new FormData();
        const fileToUpload = file.buffer ? file.buffer : fs.readFileSync(file.path);
        const fileName = file.originalname;
        formData.append('file', fileToUpload, { filename: fileName });

        // const downloadUrl = 'http://192.168.1.102:2000/digital_trim_card_ck';
        const downloadUrl = 'http://165.22.220.143:2000/digital_trim_card_ck'
        const firstResponse = await axios.post(downloadUrl, formData, {
          headers: {
            ...formData.getHeaders(),
          },
          responseType: 'json',
        });

        const { excel_base64, image_base64 } = firstResponse.data;
        const excelBuffer = Buffer.from(excel_base64, 'base64');
        const workbook = XLSX.read(excelBuffer, { type: 'buffer' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonSheet = XLSX.utils.sheet_to_json(sheet, { defval: null, raw: false });
        const extractedExcelData = jsonSheet.filter(row => Object.values(row).some(cell => cell !== null && cell !== ''));
        extractedData = extractedExcelData.flat();
        extractedData.push({ image_base64 });
      }
      return new CommonResponseModel(true, 1234, 'Data Extracted', extractedData);
    } catch (error) {
      console.error('Error during file upload and processing:', error);
      throw new Error('Failed to upload and process the files');
    }
  }



  async updatePath(files: Express.Multer.File[], excelFileName: string, pdfFileName: string, pdfFile: Express.Multer.File, randomId: any, dropDown: any): Promise<CommonResponseModel> {
    console.log(files, "files");
    console.log(pdfFile, "pdfFile");
    try {
      const entities = [];
      for (const file of files) {
        let entity;
        if (file.mimetype === 'application/pdf') {
          entity = new WfxFileUploadEntity();
          const regex = file.path
          entity.randomId = randomId;
          entity.pdfFileName = pdfFileName;
          entity.pdfFile = file.path;
          entity.originalFileName = regex.match(/pdf_files.+/)[0].replace(/(pdf_files.|pdf_files.\s+)/g, "")
          entity.createdUser = "admin";
          entity.dropDown = dropDown
          entities.push(entity);
        }
        else if (file.mimetype === 'application/octet-stream') {
          const randomIdRecord = await this.updateExcelpath(randomId)
          console.log(randomIdRecord, "randomIdRecord")
          if (randomIdRecord) {
            randomIdRecord.filePath = file.path;
            randomIdRecord.excelFileName = excelFileName;
            entities.push(randomIdRecord);
          }
        }
      }

      const uploadedFiles = await this.WfxFileRepo.save(entities);
      if (uploadedFiles) {
        return new CommonResponseModel(true, 11, 'Uploaded successfully', files);
      } else {
        return new CommonResponseModel(false, 11, 'Upload failed', files);
      }
    } catch (error) {
      console.log(error);
      return new CommonResponseModel(false, 11, 'Error uploading files', files);
    }
  }

  async updateExcelpath(randomId: any): Promise<WfxFileUploadEntity> {
    const randomIdRecord = await this.WfxFileRepo.findOne({ where: { randomId: randomId } });
    if (!randomIdRecord) {
      return this.updateExcelpath(randomId)
    }
    return randomIdRecord
  }

  async updateUnitTwelvePath(files: Express.Multer.File[], excelFileName: string, pdfFileName: string, pdfFile: Express.Multer.File, randomId: any, dropDown: any, soNumber: any): Promise<CommonResponseModel> {
    console.log(files, "files");
    console.log(pdfFile, "pdfFile");
    try {
      const entities = [];
      for (const file of files) {
        let entity;
        if (file.mimetype === 'application/pdf') {
          entity = new UnitTwelevFileUploadEntity();
          const regex = file.path
          entity.randomId = randomId;
          entity.pdfFileName = pdfFileName;
          entity.pdfFile = file.path;
          entity.originalFileName = regex.match(/pdf_files.+/)[0].replace(/(pdf_files.|pdf_files.\s+)/g, "")
          entity.createdUser = "admin";
          entity.dropDown = dropDown
          entity.soNumber = soNumber
          entities.push(entity);
        }
        else if (file.mimetype === 'application/octet-stream') {
          const randomIdRecord = await this.updateUnitTweleveRandomId(randomId)
          console.log(randomIdRecord, "randomIdRecord")
          if (randomIdRecord) {
            randomIdRecord.filePath = file.path;
            randomIdRecord.excelFileName = excelFileName;
            entities.push(randomIdRecord);
          }
        }
      }

      const uploadedFiles = await this.unitTwelveRepo.save(entities);
      if (uploadedFiles) {
        return new CommonResponseModel(true, 11, 'Uploaded successfully', files);
      } else {
        return new CommonResponseModel(false, 11, 'Upload failed', files);
      }
    } catch (error) {
      console.log(error);
      return new CommonResponseModel(false, 11, 'Error uploading files', files);
    }
  }

  async updateUnitTweleveRandomId(randomId: any): Promise<UnitTwelevFileUploadEntity> {
    const randomIdRecord = await this.unitTwelveRepo.findOne({ where: { randomId: randomId } });
    if (!randomIdRecord) {
      return this.updateUnitTweleveRandomId(randomId)
    }
    return randomIdRecord
  }

  async getPdfFileInfo(req: any): Promise<CommonResponseModel> {
    try {
      const data = await this.WfxFileRepo.getPDFInfo(req)
      if (data) {
        return new CommonResponseModel(true, 1, 'data retrived Successfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', [])
      }
    } catch (err) {
      throw err
    }
  }

  async getUnitTwelvePDFInfo(req: any): Promise<CommonResponseModel> {
    try {
      const data = await this.unitTwelveRepo.getUnitTwelvePDFInfo(req)
      if (data) {
        return new CommonResponseModel(true, 1, 'data retrived Successfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', [])
      }
    } catch (err) {
      throw err
    }
  }

  async getAllUnitTwelvePDFData(req: UnitTwelevePdfReq): Promise<CommonResponseModel> {
    try {
      let query = `SELECT utefp.id AS id,
                     utefp.excel_file_name AS excelFileName, 
                     utefp.excel_file_path AS filePath, 
                     utefp.pdf_file_name AS pdfFileName, 
                     utefp.original_file_name AS originalFileName, 
                     utefp.pdf_file AS pdfFile, 
                     utefp.buyer_name AS dropDown, 
                     utefp.so_number AS soNumber, 
                     utefp.created_at AS createdAt, 
                     utefp.created_user AS createdUser, 
                     utefp.updated_at AS updatedAt
                     FROM unit_twleve_excel_file_upload utefp
                     WHERE 1=1`; // Add a default condition

      if (req.soNumber) {
        query += ` AND utefp.so_number = '${req.soNumber}'`;
      }
      console.log(req.soNumber, "SouNumber");

      if (req.dropDown) {
        query += ` AND utefp.buyer_name = '${req.dropDown}'`;
      }
      console.log(req.dropDown, 'BuyerName');

      const data = await this.unitTwelveRepo.query(query);
      console.log(data, "data");

      if (data) {
        return new CommonResponseModel(true, 1, 'Data retrieved successfully', data);
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', []);
      }
    } catch (err) {
      throw err;
    }
  }

  async folderImageSave(filesData: any[], createdUser: string, id: number, buyer: any, materialCode: any, modifiedOriginalName: any): Promise<CommonResponseModel> {
    try {
      const fileEntities: FolderImageUploadEntity[] = [];
      filesData.forEach((file, index) => {
        const fileObj = new FolderImageUploadEntity();
        const fileEntityKeys = Object.keys(file);
        Object.keys(file).forEach((key) => {
          if (fileEntityKeys.includes(key)) {
            fileObj[key] = file[key];
          }
        });
        fileObj.id = id;
        fileObj.buyer = WfxCarharttEnum.COLUMBIA;
        fileObj.materialCode = materialCode;
        fileObj.fileName = file.filename;
        fileObj.originalName = file.originalname.replace(/\.png|\.jpg|\.jpeg|\.PNG|\.JPG|\.JPEG/g, "");
        fileObj.modifiedOriginalName = modifiedOriginalName;
        fileObj.filePath = file.path;
        fileObj.createdUser = createdUser;
        fileObj.status = TrimCardStatusEnum.OPEN;
        fileEntities.push(fileObj);
        console.log(fileObj, "fileObj");

      });
      const save = await this.folderUploadRepo.save(fileEntities);
      return new CommonResponseModel(true, 65433, "Image Uploaded Successfully", save);
    } catch (error) {
      for (const file of filesData) {
        const filesDestination = './files';
        const filePath = `${filesDestination}/${file.uid}.${file.name.substring(
          file.name.lastIndexOf('.') + 1
        )}`;
        if (fs.existsSync) {
          fs.unlinkSync(filePath);
        }
      }
      return new CommonResponseModel(false, 33565, error.message);

    }
  }

  async getAllFolderImages(): Promise<CommonResponseModel> {
    try {
      const query = `SELECT id,buyer,material_code AS materialCode,file_name AS fileName,file_path AS filePath,
                     original_name AS originalName,modified_original_name AS modifiedOriginalName,status
                     FROM folder_image_upload
                     WHERE status='OPEN'
                     `
      const result = await this.folderUploadRepo.query(query);
      if (result) {
        return new CommonResponseModel(true, 12345, 'Data Retrived Successfully', result)
      }
      else {
        return new CommonResponseModel(false, 67890, 'Data Retrived Successfully', result)
      }
    }
    catch (err) {
      return err
    }
  }

  async updateFolderImagesStatus(req?: ImageUplaodReq): Promise<CommonResponseModel> {
    console.log(req, "req");
    try {
      let query =
        ` UPDATE folder_image_upload
          SET modified_original_name ='${req.modifiedOriginalName}'
          WHERE id=${req.id} `
      const result = await this.folderUploadRepo.query(query)
      if (result) {
        return new CommonResponseModel(true, 1, 'Updated Successfully', result)
      }
    }
    catch (err) {
      return new CommonResponseModel(false, 0, err.message)
    }
  }

  async updateFolderImagesDeleteStatus(req: StyleStautsReq): Promise<CommonResponseModel> {
    try {
      const findExistedFile = await this.folderUploadRepo.findOne({ where: { id: req.id } })
      console.log(findExistedFile,'findExistedFile');
      
      if (findExistedFile?.fileName) {
        const path = join(__dirname, '../../../../', 'image_files', findExistedFile?.fileName)
        if (fs.existsSync(path)) {
          fs.unlinkSync(path)
        }
      }
      const data = await this.folderUploadRepo.delete({ id: req.id })
      if (data) {
        return new CommonResponseModel(true, 1, 'Image Deleted', data)
      }
    }
    catch (err) {
      throw err
    }
  }

  async fileSave(filesData: any[], createdUser: string, id: number, buyer: any, materialCode: any): Promise<CommonResponseModel> {
    try {
      const fileEntities: WfxImageUploadEntity[] = [];
      filesData.forEach((file, index) => {
        const fileObj = new WfxImageUploadEntity();
        const fileEntityKeys = Object.keys(file);
        Object.keys(file).forEach((key) => {
          if (fileEntityKeys.includes(key)) {
            fileObj[key] = file[key];
          }
        });
        fileObj.id = id;
        fileObj.buyer = buyer;
        fileObj.materialCode = materialCode;
        fileObj.fileName = file.filename;
        fileObj.originalName = file.originalname.replace(/\.png|\.jpg|\.jpeg|\.PNG|\.JPG|\.JPEG/g, "");
        fileObj.modifiedOriginalName = file.originalname.replace(/\.png|\.jpg|\.jpeg|\.PNG|\.JPG|\.JPEG/g, "");
        fileObj.filePath = file.path;
        fileObj.createdUser = createdUser;
        fileObj.status = TrimCardStatusEnum.OPEN;
        fileEntities.push(fileObj);
        console.log(fileObj, "fileObj");

      });
      const save = await this.fileRepo.save(fileEntities);
      return new CommonResponseModel(true, 65433, "FileUploaded Successfully", save);
    } catch (error) {
      for (const file of filesData) {
        const filesDestination = './files';
        const filePath = `${filesDestination}/${file.uid}.${file.name.substring(
          file.name.lastIndexOf('.') + 1
        )}`;
        if (fs.existsSync) {
          fs.unlinkSync(filePath);
        }
      }
      return new CommonResponseModel(false, 33565, error.message);

    }
  }

  async updateImageUploadStatus(req: StyleStautsReq): Promise<CommonResponseModel> {
    try {
      const data = await this.fileRepo.update({ id: req.id }, { status: TrimCardStatusEnum.DELETED })
      if (data.affected != 0) {
        return new CommonResponseModel(true, 1, 'Image Deleted', data)
      }
    }
    catch (err) {
      throw err
    }
  }

  async deleteFolderImagesImageUploadStatus(req: StyleStautsReq): Promise<CommonResponseModel> {
    try {
      const findExistedFile = await this.folderUploadRepo.findOne({ where: { id: req.id } })
      if (findExistedFile?.fileName) {
        const path = join(__dirname, '../../../../', 'image_files', findExistedFile?.fileName)
        if (fs.existsSync(path)) {
          fs.unlinkSync(path)
        }
      }
      const data = await this.folderUploadRepo.delete({ id: req.id })
      if (data) {
        return new CommonResponseModel(true, 1, 'Image Deleted', data)
      } else {
        return new CommonResponseModel(false, 0, 'Failed', [])
      }
    }
    catch (err) {
      throw err
    }
  }

  async getAllCarharttImages(): Promise<CommonResponseModel> {
    try {
      const query = `SELECT ip.id,ip.file_name AS fileName,ip.file_path AS filePath,
                     ip.original_name AS originalName,ip.modified_original_name AS modifiedOriginalName,ip.status
                     FROM image_upload ip
                     WHERE ip.status='OPEN'
                     `
      const result = await this.fileRepo.query(query);
      if (result) {
        return new CommonResponseModel(true, 12345, 'Data Retrived Successfully', result)
      }
      else {
        return new CommonResponseModel(false, 67890, 'Data Retrived Successfully', result)
      }
    }
    catch (err) {
      return err
    }
  }

  async saveCarharttData(req: any): Promise<CommonResponseModel> {
    try {
      const entities = [];
      const measurementDataRecords = [
        ...(req.combinedProductPlusColor.combinedFabricColorHeaders || []),
        ...(req.combinedProductPlusColor.combinedLabelColorHeaders || []),
        ...(req.combinedProductPlusColor.combinedPackingColorHeaders || [])
      ];
      for (const rec of measurementDataRecords) {
        const entity = new MeasurementDataShahiCarharttEntity();
        entity.createdUser = "admin";
        entity.measurementData = rec;
        entity.styleData = req.styleData;
        entity.seasonData = req.seasonData;
        entity.submitDate = req.submitDate;
        entities.push(entity);
      }
      const saveRecords = await this.ColorCarharttRepo.save(entities);
      if (saveRecords) {
        return new CommonResponseModel(true, 11, 'Saved successfully');
      } else {
        return new CommonResponseModel(false, 11, 'Save Failed');
      }
    } catch (error) {
      console.log(error);
      return new CommonResponseModel(false, 11, 'Error While Saving');
    }
  }

  async createCarharttData(dto: StylesDto): Promise<CommonResponseModel> {
    const transactionalManager = new GenericTransactionManager(this.dataSource)
    try {
      if (dto.dropDown === "CARHARTT") {
        await transactionalManager.startTransaction();
        const { combinedFabricColorHeaders, combinedLabelColorHeaders, combinedPackingColorHeaders, combinedTrimColorHeaders } = dto.combinedProductPlusColor
        const entities = new StylesEntity;
        entities.id = dto.id
        entities.dropDown = dto.dropDown
        entities.styleData = dto.styleData
        entities.seasonData = dto.seasonData
        entities.submitDate = dto.submitDate
        entities.styleDescription = dto.styleDescription
        entities.stateData = dto.stateData
        entities.techPack = dto.techPack
        entities.status = TrimCardStatusEnum.OPEN;
        const carharttSaveRecords = await transactionalManager.getRepository(StylesEntity).save(entities);
        let fabricRecords = []
        for (const fabric of combinedFabricColorHeaders) {
          const measurementEntity = new MeasurementDataEntity()
          measurementEntity.styles = carharttSaveRecords
          measurementEntity.measurementData = fabric;
          measurementEntity.trimCard = WfxCarharttEnum.FABRIC
          fabricRecords.push(measurementEntity)
        };
        await transactionalManager.getRepository(MeasurementDataEntity).save(fabricRecords);
        let labelRecords = []
        for (const fabric of combinedLabelColorHeaders) {
          const measurementEntity = new MeasurementDataEntity()
          measurementEntity.styles = carharttSaveRecords
          measurementEntity.measurementData = fabric;
          measurementEntity.trimCard = WfxCarharttEnum.LABEL
          labelRecords.push(measurementEntity)
        };
        await transactionalManager.getRepository(MeasurementDataEntity).save(labelRecords);
        let packingRecords = []
        for (const fabric of combinedPackingColorHeaders) {
          const measurementEntity = new MeasurementDataEntity()
          measurementEntity.styles = carharttSaveRecords
          measurementEntity.measurementData = fabric;
          measurementEntity.trimCard = WfxCarharttEnum.PACKAGINGTRIMS
          packingRecords.push(measurementEntity)
        };
        await transactionalManager.getRepository(MeasurementDataEntity).save(packingRecords);

        let trimRecords = []
        for (const fabric of combinedTrimColorHeaders) {
          const measurementEntity = new MeasurementDataEntity()
          measurementEntity.styles = carharttSaveRecords
          measurementEntity.measurementData = fabric;
          measurementEntity.trimCard = WfxCarharttEnum.TRIMS
          trimRecords.push(measurementEntity)
        };
        await transactionalManager.getRepository(MeasurementDataEntity).save(trimRecords);
        await transactionalManager.completeTransaction();
        return new CommonResponseModel(true, 1, 'Saved successfully', carharttSaveRecords);
      }

      else if (dto.dropDown === "COLUMBIA") {
        await transactionalManager.startTransaction();
        const { combinedColumbiaFabricHeaders, combinedColumbiaSewingHeaders, combinedColumbiaPackingHeaders, combinedColumbiaEmbellishmentHeaders } = dto.combinedColumbiaPlusColor
        const entities = new StylesEntity;
        entities.id = dto.id
        entities.dropDown = dto.dropDown
        entities.styleData = dto.styleData
        entities.seasonData = dto.seasonData
        entities.submitDate = dto.submitDate
        entities.styleDescription = dto.styleDescription
        entities.stateData = dto.stateData
        entities.techPack = dto.techPack
        entities.status = TrimCardStatusEnum.OPEN;
        const columbiaSaveRecords = await transactionalManager.getRepository(StylesEntity).save(entities);

        let columbiaFabricRecords = []
        for (const fabric of combinedColumbiaFabricHeaders) {
          const measurementEntity = new MeasurementDataEntity()
          measurementEntity.styles = columbiaSaveRecords
          measurementEntity.measurementData = fabric;
          measurementEntity.trimCard = WfxCarharttEnum.FABRIC
          columbiaFabricRecords.push(measurementEntity)
        };
        await transactionalManager.getRepository(MeasurementDataEntity).save(columbiaFabricRecords);

        let columbiaSewingRecords = []
        for (const sewing of combinedColumbiaSewingHeaders) {
          const measurementEntity = new MeasurementDataEntity()
          measurementEntity.styles = columbiaSaveRecords
          measurementEntity.measurementData = sewing;
          measurementEntity.trimCard = WfxCarharttEnum.SEWING
          columbiaSewingRecords.push(measurementEntity)
        };
        await transactionalManager.getRepository(MeasurementDataEntity).save(columbiaSewingRecords);

        let columbiaPackingRecords = []
        for (const packing of combinedColumbiaPackingHeaders) {
          const measurementEntity = new MeasurementDataEntity()
          measurementEntity.styles = columbiaSaveRecords
          measurementEntity.measurementData = packing;
          measurementEntity.trimCard = WfxCarharttEnum.PACKING
          columbiaPackingRecords.push(measurementEntity)
        };
        await transactionalManager.getRepository(MeasurementDataEntity).save(columbiaPackingRecords);

        let columbiaEmblishmentRecords = []
        for (const emblishment of combinedColumbiaEmbellishmentHeaders) {
          const measurementEntity = new MeasurementDataEntity()
          measurementEntity.styles = columbiaSaveRecords
          measurementEntity.measurementData = emblishment;
          measurementEntity.trimCard = WfxCarharttEnum.EMBELLISHMENT
          columbiaEmblishmentRecords.push(measurementEntity)
        };
        await transactionalManager.getRepository(MeasurementDataEntity).save(columbiaEmblishmentRecords);

        await transactionalManager.completeTransaction();
        return new CommonResponseModel(true, 1, 'Saved successfully', columbiaSaveRecords);
      }

      else if (dto.dropDown === "CK") {
        await transactionalManager.startTransaction();
        const { combinedCKFabricAndLiningColorHeaders, combinedCKZippersColorHeaders, combinedCKTrimsColorHeaders } = dto.combinedCKPlusColor
        const entities = new StylesEntity;
        entities.id = dto.id
        entities.dropDown = dto.dropDown
        entities.styleData = dto.styleData
        entities.seasonData = dto.seasonData
        entities.submitDate = dto.submitDate
        entities.styleDescription = dto.styleDescription
        entities.stateData = dto.stateData
        entities.techPack = dto.techPack
        entities.status = TrimCardStatusEnum.OPEN;
        const carharttSaveRecords = await transactionalManager.getRepository(StylesEntity).save(entities);

        let fabricRecords = []
        for (const fabric of combinedCKFabricAndLiningColorHeaders) {
          const measurementEntity = new MeasurementDataEntity()
          measurementEntity.styles = carharttSaveRecords
          measurementEntity.measurementData = fabric.replace(/\s+\|+.+/g, "")
          measurementEntity.trimCard = WfxCarharttEnum.FABRICLINING
          measurementEntity.color = fabric.replace(/.*?\|\|\|/g, "")
          fabricRecords.push(measurementEntity)
        };
        await transactionalManager.getRepository(MeasurementDataEntity).save(fabricRecords);

        let zippersRecords = []
        for (const zipper of combinedCKZippersColorHeaders) {
          const measurementEntity = new MeasurementDataEntity()
          measurementEntity.styles = carharttSaveRecords
          measurementEntity.measurementData = zipper.replace(/\s+\|+.+/g, "")
          measurementEntity.trimCard = WfxCarharttEnum.ZIPPERS
          measurementEntity.color = zipper.replace(/.*?\|\|\|/g, "")
          zippersRecords.push(measurementEntity)
        };
        await transactionalManager.getRepository(MeasurementDataEntity).save(zippersRecords);

        let trimsRecords = []
        for (const trim of combinedCKTrimsColorHeaders) {
          const measurementEntity = new MeasurementDataEntity()
          measurementEntity.styles = carharttSaveRecords
          measurementEntity.measurementData = trim.replace(/\s+\|+.+/g, "")
          measurementEntity.trimCard = WfxCarharttEnum.TRIMS
          measurementEntity.color = trim.replace(/.*?\|\|\|/g, "")
          trimsRecords.push(measurementEntity)
        };
        await transactionalManager.getRepository(MeasurementDataEntity).save(trimsRecords);

        await transactionalManager.completeTransaction();
        return new CommonResponseModel(true, 1, 'Saved successfully', carharttSaveRecords);
      }
    } catch (error) {
      console.log(error);
      await transactionalManager.releaseTransaction();
      return new CommonResponseModel(false, 11, 'Error While Saving');
    }
  }

  async createCKDigitalTrimCard(dto: MeasurementDataDTO): Promise<CommonResponseModel> {
    try {
      const entity = new MeasurementDataEntity;
      entity.id = dto.id
      entity.measurementData = dto.measurementData;
      entity.color = dto.color;
      entity.trimCard = dto.trimCard;
      entity.status = UnitSevenStatusEnum.OPEN;
      entity.styleId = dto.styleId
      const result = await this.measurementRepo.save(entity)
      if (result) {
        return new CommonResponseModel(true, 9848032919, "Trim Card Created", result)
      }
    }
    catch (err) {
      console.log(err);
      return new CommonResponseModel(false, 11, 'Error While Saving');
    }
  }

  async getAllCarharttMeasurementData(): Promise<CommonResponseModel> {
    try {
      const dto = new StylesDto()
      const data = await this.styleRepo.getAllCarharttMeasurementData();
      for (const ele of data) {
        const s = new StylesEntity();
        s.id = ele.id;

        //GET CARHARTT DATA
        const fabricData = await this.measurementRepo.find({ relations: ['styles'], where: { styles: s, trimCard: WfxCarharttEnum.FABRIC, status: UnitSevenStatusEnum.OPEN } });
        for (const item of fabricData) {
          ele.combinedProductPlusColor.combinedFabricColorHeaders.push(new MeasurementDataReq(item.id, item.styles.id, item.measurementData, item.status))
        }

        const labelData = await this.measurementRepo.find({ relations: ['styles'], where: { styles: s, trimCard: WfxCarharttEnum.LABEL, status: UnitSevenStatusEnum.OPEN } });
        for (const item of labelData) {
          ele.combinedProductPlusColor.combinedLabelColorHeaders.push(new MeasurementDataReq(item.id, item.styles.id, item.measurementData, item.status))
        }

        const packingData = await this.measurementRepo.find({ relations: ['styles'], where: { styles: s, trimCard: WfxCarharttEnum.PACKAGINGTRIMS, status: UnitSevenStatusEnum.OPEN } });
        for (const item of packingData) {
          ele.combinedProductPlusColor.combinedPackingColorHeaders.push(new MeasurementDataReq(item.id, item.styles.id, item.measurementData, item.status))
        }

        const trimData = await this.measurementRepo.find({ relations: ['styles'], where: { styles: s, trimCard: WfxCarharttEnum.TRIMS, status: UnitSevenStatusEnum.OPEN } });
        for (const item of trimData) {
          ele.combinedProductPlusColor.combinedTrimColorHeaders.push(new MeasurementDataReq(item.id, item.styles.id, item.measurementData, item.status))
        }

        //GET COLUMBIA DATA
        const columbiaFabricData = await this.measurementRepo.find({ relations: ['styles'], where: { styles: s, trimCard: WfxCarharttEnum.FABRIC } });
        for (const item of columbiaFabricData) {
          ele.combinedColumbiaPlusColor.combinedColumbiaFabricHeaders.push(new MeasurementDataReq(item.id, item.styles.id, item.measurementData, item.status))
        }
        console.log(columbiaFabricData, 'columbiaFabricData');

        const columbiaSewingData = await this.measurementRepo.find({ relations: ['styles'], where: { styles: s, trimCard: WfxCarharttEnum.SEWING } });
        for (const item of columbiaSewingData) {
          ele.combinedColumbiaPlusColor.combinedColumbiaSewingHeaders.push(new MeasurementDataReq(item.id, item.styles.id, item.measurementData, item.status))
        }
        const columbiaPackingData = await this.measurementRepo.find({ relations: ['styles'], where: { styles: s, trimCard: WfxCarharttEnum.PACKING } });
        for (const item of columbiaPackingData) {
          ele.combinedColumbiaPlusColor.combinedColumbiaPackingHeaders.push(new MeasurementDataReq(item.id, item.styles.id, item.measurementData, item.status))
        }
        const columbiaEmbellishmentData = await this.measurementRepo.find({ relations: ['styles'], where: { styles: s, trimCard: WfxCarharttEnum.EMBELLISHMENT } });
        for (const item of columbiaEmbellishmentData) {
          ele.combinedColumbiaPlusColor.combinedColumbiaEmbellishmentHeaders.push(new MeasurementDataReq(item.id, item.styles.id, item.measurementData, item.status))
        }

        //GET CK and TOMMY DATA
        const ckFabricData = await this.measurementRepo.find({ relations: ['styles'], where: { styles: s, trimCard: WfxCarharttEnum.FABRICLINING, status: UnitSevenStatusEnum.OPEN } });
        for (const item of ckFabricData) {
          ele.combinedCKPlusColor.combinedCKFabricAndLiningColorHeaders.push(new MeasurementDataReq(item.id, item.styles.id, item.measurementData, item.status, item.color, item.shade))
        }

        const ckZippersData = await this.measurementRepo.find({ relations: ['styles'], where: { styles: s, trimCard: WfxCarharttEnum.ZIPPERS, status: UnitSevenStatusEnum.OPEN } });
        for (const item of ckZippersData) {
          ele.combinedCKPlusColor.combinedCKZippersColorHeaders.push(new MeasurementDataReq(item.id, item.styles.id, item.measurementData, item.status, item.color, item.shade))
        }

        const ckTrimsData = await this.measurementRepo.find({ relations: ['styles'], where: { styles: s, trimCard: WfxCarharttEnum.TRIMS, status: UnitSevenStatusEnum.OPEN } });
        for (const item of ckTrimsData) {
          ele.combinedCKPlusColor.combinedCKTrimsColorHeaders.push(new MeasurementDataReq(item.id, item.styles.id, item.measurementData, item.status, item.color, item.shade))
        }

      }
      return new CommonResponseModel(true, 1, 'Data Retrived', data)
    }
    catch (error) {
      throw error;
    }
  }

  async getAllCarharttMeasurementDataPDMFolders(): Promise<CommonResponseModel> {
    try {
      const dto = new StylesDto()
      const data = await this.styleRepo.getAllCarharttMeasurementDataPDMFolders();
      for (const ele of data) {
        const s = new StylesEntity();
        s.id = ele.id;
        //GET COLUMBIA DATA
        const columbiaFabricData = await this.measurementRepo.find({ relations: ['styles'], where: { styles: s, trimCard: WfxCarharttEnum.FABRIC } });
        for (const item of columbiaFabricData) {
          ele.combinedColumbiaPlusColor.combinedColumbiaFabricHeaders.push(new MeasurementDataReq(item.id, item.styles.id, item.measurementData, item.status))
        }
        const columbiaSewingData = await this.measurementRepo.find({ relations: ['styles'], where: { styles: s, trimCard: WfxCarharttEnum.SEWING } });
        for (const item of columbiaSewingData) {
          ele.combinedColumbiaPlusColor.combinedColumbiaSewingHeaders.push(new MeasurementDataReq(item.id, item.styles.id, item.measurementData, item.status))
        }
        const columbiaPackingData = await this.measurementRepo.find({ relations: ['styles'], where: { styles: s, trimCard: WfxCarharttEnum.PACKING } });
        for (const item of columbiaPackingData) {
          ele.combinedColumbiaPlusColor.combinedColumbiaPackingHeaders.push(new MeasurementDataReq(item.id, item.styles.id, item.measurementData, item.status))
        }
        const columbiaEmbellishmentData = await this.measurementRepo.find({ relations: ['styles'], where: { styles: s, trimCard: WfxCarharttEnum.EMBELLISHMENT } });
        for (const item of columbiaEmbellishmentData) {
          ele.combinedColumbiaPlusColor.combinedColumbiaEmbellishmentHeaders.push(new MeasurementDataReq(item.id, item.styles.id, item.measurementData, item.status))
        }
      }
      return new CommonResponseModel(true, 1, 'Data Retrived', data)
    }
    catch (error) {
      throw error;
    }
  }

  async updateThreadsShadeCK(req: CkMeasurementDataThreadsReq): Promise<CommonResponseModel> {
    try {
      let query = `UPDATE measurement_data
                 SET shade="${req.shade}"
                 WHERE id ="${req.id}" `
      const result = await this.measurementRepo.query(query)
      if (result.affected != 0) {
        return new CommonResponseModel(true, 1, "Shade Updated", result)
      } else {
        return new CommonResponseModel(false, 0, "Fail")
      }
    }
    catch (err) {
      throw err
    }
  }

  async updateLabelHangtagsDescriptionCK(req: CKMeasurementLabelHangtagReq): Promise<CommonResponseModel> {
    try {
      const idsArray = Array.isArray(req.id) ? req.id : [req.id];
      const ids = idsArray.join(",");

      let query = `UPDATE measurement_data
                 SET measurement_data = '${req.measurement}' 
                 WHERE id IN (${ids}) AND style_id = ${req.styleId};`
      const result = await this.measurementRepo.query(query)
      if (result.affected != 0) {
        return new CommonResponseModel(true, 1, "Description Updated", result)
      } else {
        return new CommonResponseModel(false, 0, "Fail")
      }
    }
    catch (err) {
      throw err
    }
  }

  async deleteBlockCK(req: CKMeasurementStatusDeleteBlockReq): Promise<CommonResponseModel> {
    try {
      const idsArray = Array.isArray(req.id) ? req.id : [req.id];
      const ids = idsArray.join(",");

      let query = `UPDATE measurement_data
                 SET status = "DELETED" 
                 WHERE id IN (${ids}) AND style_id = ${req.styleId};`
      const result = await this.measurementRepo.query(query);
      if (result.affected !== 0) {
        return new CommonResponseModel(true, 8309649082, "Deleted", result)
      }
      else {
        return new CommonResponseModel(false, 6281481725, "Fail to Delete")
      }
    }
    catch (err) {
      throw err
    }
  }

  async updateTrimCardView(req: TrimCardUpdateReq): Promise<CommonResponseModel> {
    let query = `UPDATE styles_entity
                 SET submit_date="${req.submitDate}",
                    season = "${req.seasonData}",
                    style = "${req.styleData}",
                    style_description="${req.styleDescription}",
                    factory="${req.factory}",
                    approval_type="${req.approvalType}",
                    state_data="${req.stateData}",
                    factory_merchandiser_sign="${req.factoryMerchandiserSign}",
                    comments="${req.comments}",
                    approved_by="${req.approvedBy}"
                    WHERE id=${req.id}`
    const result = await this.styleRepo.query(query)
    if (result.affected != 0) {
      return new CommonResponseModel(true, 1, "Trim Card Updated", result)
    } else {
      return new CommonResponseModel(false, 0, "Fail")
    }
  }

  async getStylesFileName(req: any): Promise<CommonResponseModel> {
    try {
      let query = ` SELECT s.id,s.pdf_file_name AS fileName,s.status   FROM styles_entity s`
      const result = await this.styleRepo.query(query)
      if (result) {
        return new CommonResponseModel(true, 1, "Success", result)
      } else {
        return new CommonResponseModel(false, 0, "Fail")
      }
    } catch (err) {
      console.log(err);
    }
  }

  async updateColumbiaCardUNDO(req: any): Promise<CommonResponseModel> {
    console.log(req, '9898989898898989898');

    try {
      const result = await this.measurementRepo.update({ id: req.id, styleId: req.styleId }, { status: UnitSevenStatusEnum.OPEN })
      if (result) {
        return new CommonResponseModel(true, 1, "UNDO Success", result)
      } else {
        return new CommonResponseModel(false, 0, "UNDO Failed")
      }
    } catch (err) {
      console.log(err);
    }
  }

  async updateStatusStyle(req: StyleStautsReq): Promise<CommonResponseModel> {
    try {
      const data = await this.styleRepo.update({ id: req.id }, { status: TrimCardStatusEnum.DELETED })
      if (data) {
        return new CommonResponseModel(true, 1, 'Status Updated', data)
      }
    }
    catch (err) {
      throw err
    }
  }

  // async updateTrimCardFileSave(filePath: string, filename: string, id: number, originalname: string): Promise<CommonResponseModel> {
  //   try {
  //     const filePathUpdate = await this.styleRepo.update(
  //       { id: id },
  //       { filePath: filePath, fileName: filename, originalname: originalname },
  //     );
  //     // console.log(filePath, "filePath");
  //     // console.log(filename, "fileName");
  //     // console.log(filePathUpdate, "filePathUpdate")
  //     if (filePathUpdate.affected > 0) {
  //       return new CommonResponseModel(true, 11, 'Uploaded successfully', filePathUpdate);
  //     }
  //     else {
  //       return new CommonResponseModel(false, 11, 'Uploaded failed', filePathUpdate);
  //     }
  //   }
  //   catch (error) {
  //     console.log(error);
  //   }
  // }


  async updateTrimCardFileSave(filePath: string, filename: string, id: number, originalname: string, base64?: any, imageFiles?: any, imageOriginalName?: any): Promise<CommonResponseModel> {
    try {

      const blob = Buffer.from(base64, 'base64')
      // const imageFilePath = fs.writeFileSync(join(__dirname, '../../../../','files',`${filename.replace(/.pdf|.PDF/g,".jpeg")}`),blob)
      const imageFilePath = join(__dirname, '../../../../', 'files', `${filename.replace(/.pdf|.PDF/g, ".jpeg")}`);
      fs.writeFileSync(imageFilePath, blob);
      // console.log(join(__dirname, '../../../../','upload_files',`${filename}`),"///////////////////////////////////////////")
      // console.log(join(__dirname, '../../../../','upload_files'),"/8*****/87777777777")
      const imagefileOriginalName = filename.replace(/.pdf|.PDF/g, ".jpeg")
      const filePathUpdate = await this.styleRepo.update(
        { id: id },
        { filePath: filePath, fileName: filename, originalname: originalname, imageFiles: imageFilePath, imageOriginalName: imagefileOriginalName },
      );

      if (filePathUpdate.affected > 0) {
        return new CommonResponseModel(true, 11, 'Uploaded successfully', filePathUpdate);
      } else {
        return new CommonResponseModel(false, 11, 'Upload failed', filePathUpdate);
      }
    } catch (error) {
      console.error('Error updating file paths', error);
      throw new Error('File update failed');
    }
  }

  async getImageNames(req: any): Promise<CommonResponseModel> {
    try {
      const data = await this.imagesRepo.find()
      if (data) {
        return new CommonResponseModel(true, 1, 'Data retrived Successfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', [])
      }
    } catch (err) {
      throw err
    }
  }

  async saveBuyer(req: any, isUpdate: boolean): Promise<CommonResponseModel> {

    try {
      if (req.id) {
        const existingBuyer = await this.buyerRepo.count({ where: { buyer: req.buyer, id: Not(req.id), status: UnitSevenStatusEnum.OPEN } });
        if (existingBuyer) {
          return new CommonResponseModel(false, 8214, "Buyer Already Exists");
        }
      } else {
        const existingBuyer = await this.buyerRepo.findOne({ where: { buyer: req.buyer, status: UnitSevenStatusEnum.OPEN } });
        if (existingBuyer) {
          return new CommonResponseModel(false, 9632, "Buyer Already Exists");
        }
      }
      const entity = new BuyerEntity();
      entity.buyer = req.buyer;
      if (req.id) {
        entity.id = req.id
        entity.updatedUser = req.updatedUser
      } else {
        entity.createdUser = req.createdUser
      }
      const saveBuyer = await this.buyerRepo.save(entity)
      return new CommonResponseModel(true, 1, "Buyer Created", saveBuyer)

    } catch (error) {
      return new CommonResponseModel(false, 0, error.message)

    }

  }

  async buyerFileSave(filePath: string, filename: string, id: number, originalname: string): Promise<CommonResponseModel> {
    try {
      const findExistedFile = await this.buyerRepo.findOne({ where: { id: id } })
      if (findExistedFile?.fileName) {
        const path = join(__dirname, '../../../../', 'image_files', findExistedFile?.fileName)
        if (fs.existsSync(path)) {
          fs.unlinkSync(path)
        }

      }
      const filePathUpdate = await this.buyerRepo.update(
        { id: id },
        { filePath: filePath, fileName: filename, originalname: originalname },
      );
      if (filePathUpdate.affected > 0) {
        return new CommonResponseModel(true, 11, 'Uploaded successfully', filePath);
      }
      else {
        return new CommonResponseModel(false, 11, 'Uploaded failed', filePath);
      }
    }
    catch (error) {
      console.log(error);
    }
  }

  async getAllBuyers(req?: any): Promise<CommonResponseModel> {
    // 1. Fetch all buyers with status "OPEN"
    let query = `SELECT id, buyer, file_path AS filePath, file_name AS fileName, original_name AS originalname, status
               FROM buyer_master
               WHERE status="OPEN"`;
    const result = await this.buyerRepo.query(query);

    // 2. Fetch all buyers with status "DELETED"
    let deletedQuery = `SELECT id FROM buyer_master WHERE status="DELETED"`;
    const deletedResult = await this.buyerRepo.query(deletedQuery);

    // 3. If there are any buyers with status "DELETED", update their corresponding records in parameter_master
    if (deletedResult.length > 0) {
      const deletedBuyerIds = deletedResult.map((buyer: any) => buyer.id);
      // Update the status of corresponding buyers in parameter_master to 'DELETED'
      let updateQuery = `UPDATE parameter_master SET status = 'DELETED' WHERE buyer IN (${deletedBuyerIds.join(",")})`;
      await this.parameterRepo.query(updateQuery);
      console.log(deletedBuyerIds, 'deletedBuyerIds');
      console.log(updateQuery, 'updateQuery');
    } else {
      console.log('No buyers found with status DELETED');
    }

    // 4. Return the result for buyers with status "OPEN"
    if (result) {
      return new CommonResponseModel(true, 1, "Success", result);
    } else {
      return new CommonResponseModel(false, 0, "Fail");
    }
  }


  async saveParameter(req: any): Promise<CommonResponseModel> {
    try {
      const entities = [];
      for (const rec of req.parameters) {
        const data = new ParameterEntity()
        data.buyer = req.buyer;
        data.parameter = rec.parameter;
        entities.push(data)
      }
      await this.parameterRepo.save(entities);
      return new CommonResponseModel(true, 1, 'Parameter Created', entities)
    } catch (err) {
      return err
    }
  }

  async getAllParameters(): Promise<CommonResponseModel> {
    let query = `SELECT b.buyer,
                 GROUP_CONCAT(p.parameter ORDER BY p.id SEPARATOR '+ ') AS parameter
                 FROM parameter_master p
                 LEFT JOIN buyer_master b ON b.id = p.buyer
                 WHERE p.status="OPEN"
                 GROUP BY b.buyer`
    const result = await this.parameterRepo.query(query)
    if (result) {
      return new CommonResponseModel(true, 1, "Success", result)
    } else {
      return new CommonResponseModel(false, 0, "Fail")
    }
  }

  async updateImageUpload(req?: ImageUplaodReq): Promise<CommonResponseModel> {
    try {
      let query =
        ` UPDATE image_upload
          SET modified_original_name ='${req.modifiedOriginalName}'
          WHERE id=${req.id} `
      const result = await this.fileRepo.query(query)
      if (result) {
        return new CommonResponseModel(true, 1, 'Updated Successfully', result)
      }
    }
    catch (err) {
      return new CommonResponseModel(false, 0, err.message)
    }
  }

  async TrimCardImageSave(filesData: any[], createdUser: string, id: number, buyer: any, parameter: any): Promise<CommonResponseModel> {
    try {
      const fileEntities: WfxImageUploadEntity[] = [];
      filesData.forEach((file) => {
        const fileObj = new WfxImageUploadEntity();
        fileObj.id = id;
        fileObj.buyer = buyer;
        fileObj.fileName = file.filename;
        fileObj.originalName = file.originalname.replace(/\.png|\.jpg|\.jpeg|\.PNG|\.JPG|\.JPEG/g, "");
        fileObj.modifiedOriginalName = file.originalname.replace(/\.png|\.jpg|\.jpeg|\.PNG|\.JPG|\.JPEG/g, "");
        fileObj.filePath = file.path;
        fileObj.createdUser = createdUser;
        fileEntities.push(fileObj);
      });
      const save = await this.fileRepo.save(fileEntities);
      return new CommonResponseModel(true, 65433, "FileUploaded Successfully");
    } catch (error) {
      return new CommonResponseModel(false, 33565, error.message);
    }
  }

  // async saveUnitTwelveExcelData(req: any): Promise<CommonResponseModel> {
  //   console.log(req, "req8888888888888");
  //   try {
  //     const entities = [];
  //     for (const rec of req) {
  //       const data = new UnitTweleveExcelDataEntity();
  //       data.soNumber = rec['SO Number'];
  //       data.placeOfSupply = rec['Place of Supply'];
  //       data.shipToCustomer = rec['Ship To Customer'];
  //       data.customerPo = rec['Customer PO'];
  //       data.itemDescription = rec['Item Description'];
  //       data.hsnCode = rec['HSN Code'];
  //       data.Qty = rec['Qty'];
  //       data.unitPrice = rec['Unit Price'];
  //       data.uom = rec['UOM'];
  //       data.netAmount = rec['Net Amount INR'];
  //       data.color = rec['Color'];
  //       data.size = rec['Size'];
  //       data.qtyWiseData = rec['Qty Wise Data'];
  //       data.tax = rec['Tax'];
  //       entities.push(data);
  //     }
  //     await this.unittweleveexcelRepo.save(entities);
  //     return new CommonResponseModel(true, 1, 'Saved Successfully', entities);
  //   } catch (err) {
  //     return new CommonResponseModel(false, 0, 'Error saving data', err);
  //   }
  // }
  async saveUnitTwelveExcelData(req: any): Promise<CommonResponseModel> {
    try {
      const entities = [];
      const compressedArrayOfData = Array.isArray(req[0]) ? req.flat() : req;

      for (const rec of compressedArrayOfData) {
        const data = new UnitTweleveExcelDataEntity();
        data.soNumber = rec['SO Number'];
        data.placeOfSupply = rec['Place of Supply'];
        data.shipToCustomer = rec['Ship To Customer'];
        data.customerPo = rec['Customer PO'];
        data.itemDescription = rec['Item Description'];
        data.hsnCode = rec['HSN Code'];
        data.Qty = rec['Qty'];
        data.unitPrice = rec['Unit Price'];
        data.uom = rec['UOM'];
        data.netAmount = rec['Net Amount INR'];
        data.color = rec['Color'];
        data.size = rec['Size'];
        data.qtyWiseData = rec['Qty Wise Data'];
        data.tax = rec['Tax'];
        entities.push(data);
      }

      await this.unittweleveexcelRepo.save(entities);
      return new CommonResponseModel(true, 1, 'Saved Successfully', entities);
    } catch (err) {
      return new CommonResponseModel(false, 0, 'Error saving data', err);
    }
  }

  async getAllPdfsData(): Promise<CommonResponseModel> {
    try {
      let query = `SELECT uted.id AS id,
                   uted.so_number AS soNumber,uted.place_of_supply AS placeOfSupply,uted.ship_to_customer AS shipToCustomer,
                   uted.customer_po AS customerPo,uted.item_description AS itemDescription,uted.hsn_code AS hsnCode,
                   uted.qty AS qty,uted.unit_price AS unitPrice,uted.uom AS uom,
                   uted.net_amount AS netAmount,uted.color AS color,uted.size AS size,
                   uted.qty_wise_data AS qtyWiseData,uted.tax as tax,uted.is_active AS isActive,uted.created_at AS createdAt,
                   uted.created_user AS createdUser
                   FROM unit_twelve_excel_data uted
                    `
      const result = await this.unittweleveexcelRepo.query(query)
      if (result) {
        return new CommonResponseModel(true, 123, 'Data Retrived', result)
      }
    }
    catch (err) {
      throw err
    }
  }

  async getAllVersions(req: WFXIdReqDto): Promise<CommonResponseModel> {
    const data = await this.versionsApparelRepo.findOne({ select: ['rawData'], where: { id: req.wfxId } });
    if (data) {
      const rawData = JSON.parse(data.rawData);
      rawData.articleApparelMaster[0].remarks = rawData.articleApparelMaster[0].remarks ? rawData.articleApparelMaster[0].remarks : ' '
      delete rawData.articleApparelMaster[0].role
      data.rawData = rawData
      return new CommonResponseModel(true, 55612, "Data Retrieved Successfully", data.rawData)
    } else {
      return new CommonResponseModel(false, 21655, "No Data Found")
    }
  }

  async getVersionsGridData(req: WFXIdReqDto): Promise<CommonResponseModel> {
    const apparelEn = new ApparelArticleMaster();
    apparelEn.id = req.wfxId
    const data = await this.versionsApparelRepo.find({ select: ['approvalStatus', 'role', 'bomNumber', 'id', 'created', 'status', 'techPack', 'department', 'brand'], where: { apparelArticleId: apparelEn } })
    if (data.length) {
      return new CommonResponseModel(true, 54545, "Data Retrieved Successfully", data)
    } else {
      return new CommonResponseModel(false, 96325, "Data Not Found", [])
    }
  }

  async createVersions(req: any): Promise<CommonResponseModel> {
    const transactionalManager = new GenericTransactionManager(this.dataSource);
    try {
      await transactionalManager.startTransaction();
      let internalMessage;
      const findVersionRecord = await this.versionsApparelRepo.findOne({ where: { techPack: req.articleApparelMaster[0]['Tech Pack'], role: req.articleApparelMaster[0]['role'] } })
      if (findVersionRecord) {
        const apparelAMEntity = new ApparelArticleMasterVersions();
        apparelAMEntity.id = findVersionRecord.id;
        await transactionalManager.getRepository(FabricTrimsMasterVersions).delete({ versionApparelArticleId: apparelAMEntity });
        await transactionalManager.getRepository(MeasurementChart2TVersions).delete({ versionApparelArticleId: apparelAMEntity });
        await transactionalManager.getRepository(MeasurementChartMonthsVersions).delete({ versionApparelArticleId: apparelAMEntity });
        await transactionalManager.getRepository(ApparelArticleMasterVersions).delete({ techPack: req.articleApparelMaster[0]['Tech Pack'], role: req.articleApparelMaster[0]['role'] })
        internalMessage = 'Version Updated Successfully'
      } else {
        internalMessage = 'Version Created Successfully'
      }
      const apparel = this.WFXAdapter.convertVersionsArticleApparelMasterDtoToEntity(req.articleApparelMaster[0], JSON.stringify(req))
      const saveApparel = await transactionalManager.getRepository(ApparelArticleMasterVersions).save(apparel);
      const saveApparelId = saveApparel.id
      const fabric = this.WFXAdapter.convertVersionsFabricDtoToEntity(req.fabricData, ArticleTextileType.FABRICMASTER, saveApparelId)
      await transactionalManager.getRepository(FabricTrimsMasterVersions).save(fabric);
      const trim = this.WFXAdapter.convertVersionsFabricDtoToEntity(req.trimData, ArticleTextileType.TRIMMASTER, saveApparelId)
      await transactionalManager.getRepository(FabricTrimsMasterVersions).save(trim);
      const measurement2TData = this.WFXAdapter.convertVersionsMeasurement2TDataDtoEntity(req.measurement2TData, saveApparelId);
      await transactionalManager.getRepository(MeasurementChart2TVersions).save(measurement2TData);
      const measurement6MonthsData = this.WFXAdapter.convertVersionsMeasurement6MonthsDataDtoToEntity(req.measurement6MonthsData, saveApparelId);
      await transactionalManager.getRepository(MeasurementChartMonthsVersions).save(measurement6MonthsData);
      await transactionalManager.completeTransaction();
      return new CommonResponseModel(true, 5685, internalMessage);
    } catch (error) {
      await transactionalManager.releaseTransaction();
      return new CommonResponseModel(false, 8698, error.message);
    }
  }

  async deleteArticleApparelMaster(apparelId: number, deleteVersion?: boolean): Promise<CommonResponseModel> {
    const transactionalManager = new GenericTransactionManager(this.dataSource);
    try {
      await transactionalManager.startTransaction();
      const apparelAMEntity = new ApparelArticleMaster();
      apparelAMEntity.id = apparelId;
      if (deleteVersion) {
        const versionsApparelId = await this.versionsApparelRepo.findOne({ select: ['id'], where: { apparelArticleId: apparelAMEntity } })
        const versionsApparelAMEntity = new ApparelArticleMasterVersions();
        versionsApparelAMEntity.id = versionsApparelId.id;
        await transactionalManager.getRepository(FabricTrimsMasterVersions).delete({ versionApparelArticleId: versionsApparelAMEntity });
        await transactionalManager.getRepository(MeasurementChart2TVersions).delete({ versionApparelArticleId: versionsApparelAMEntity });
        await transactionalManager.getRepository(MeasurementChartMonthsVersions).delete({ versionApparelArticleId: versionsApparelAMEntity });
        await transactionalManager.getRepository(ApparelArticleMasterVersions).delete({ id: versionsApparelId.id });
      }
      await transactionalManager.getRepository(FabricTrimsMaster).delete({ apparelArticleId: apparelAMEntity });
      await transactionalManager.getRepository(MeasurementChart2T).delete({ apparelArticleId: apparelAMEntity });
      await transactionalManager.getRepository(MeasurementChartMonths).delete({ apparelArticleId: apparelAMEntity });
      await transactionalManager.getRepository(ApparelArticleMaster).delete({ id: apparelId });
      const fileName = await this.fileRepo.findOne({ where: { referenceFeatureId: apparelId, referenceFeature: ReferenceFeatureEnum.TECH_PACK } })
      await transactionalManager.getRepository(WfxImageUploadEntity).delete({ referenceFeatureId: apparelId, referenceFeature: ReferenceFeatureEnum.TECH_PACK })
      const existedFileName = join(__dirname, '../../../../', 'image_files', fileName.fileName)
      if (fs.existsSync(existedFileName)) {
        fs.unlinkSync(existedFileName)
      }
      await transactionalManager.completeTransaction()
      return new CommonResponseModel(true, 9695, "Deleted Successfully")
    } catch (error) {
      await transactionalManager.releaseTransaction();
      return new CommonResponseModel(false, 89365, error.message);
    }


  }

  async saveTechPackData(file: any[], req: any): Promise<CommonResponseModel> {
    const transactionalManager = new GenericTransactionManager(this.dataSource);
    try {

      if (!req?.articleApparelMaster?.[0]?.id) {
        const findDuplicateRecords = await this.apparelAMrepo.count({ where: { techPack: req.articleApparelMaster[0]['Tech Pack'], role: req.articleApparelMaster[0]['role'] } })
        if (findDuplicateRecords) {
          return new CommonResponseModel(false, 6525, "Tech Pack Data Already Exist")
        }
      } else {
        return await this.createVersions(req)
      }
      await transactionalManager.startTransaction();
      const convertToDate = (dateString: string): Date => {
        const [month, day, year] = dateString.split('/');
        return new Date(`${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`);
      };
      const convertArticleApparelMasterDtoToEntity = this.WFXAdapter.convertArticleApparelMasterDtoToEntity(req.articleApparelMaster[0], JSON.stringify(req))
      convertArticleApparelMasterDtoToEntity.created = convertToDate(req.articleApparelMaster[0]['Created']);
      convertArticleApparelMasterDtoToEntity.modified = convertToDate(req.articleApparelMaster[0]['Modified']);
      const saveArticleApparelMaster = await transactionalManager.getRepository(ApparelArticleMaster).save(convertArticleApparelMasterDtoToEntity)
      const fabricDtoToEntity = this.WFXAdapter.convertFabricDtoToEntity(req.fabricData, ArticleTextileType.FABRICMASTER, saveArticleApparelMaster.id)
      await transactionalManager.getRepository(FabricTrimsMaster).save(fabricDtoToEntity)
      const trimDataDtoToEntity = this.WFXAdapter.convertFabricDtoToEntity(req.trimData, ArticleTextileType.TRIMMASTER, saveArticleApparelMaster.id)
      await transactionalManager.getRepository(FabricTrimsMaster).save(trimDataDtoToEntity)
      const measurement2TData = this.WFXAdapter.convertMeasurement2TDataDtoEntity(req.measurement2TData, convertArticleApparelMasterDtoToEntity.id);
      await transactionalManager.getRepository(MeasurementChart2T).save(measurement2TData);
      const measurement6MonthsData = this.WFXAdapter.convertMeasurement6MonthsDataDtoToEntity(req.measurement6MonthsData, convertArticleApparelMasterDtoToEntity.id);
      await transactionalManager.getRepository(MeasurementChartMonths).save(measurement6MonthsData);
      const fileEntities = [];
      file.forEach((file) => {
        // console.log(file,"file")
        const fileObj = new WfxImageUploadEntity();
        fileObj.referenceFeatureId = saveArticleApparelMaster.id;
        fileObj.referenceFeature = ReferenceFeatureEnum.TECH_PACK
        fileObj.fileName = file.filename;
        fileObj.originalName = file.originalname.replace(/\.png|\.jpg|\.jpeg|\.PNG|\.JPG|\.JPEG/g, "");
        fileObj.modifiedOriginalName = file.originalname.replace(/\.png|\.jpg|\.jpeg|\.PNG|\.JPG|\.JPEG/g, "");
        fileObj.filePath = file.path;
        fileEntities.push(fileObj);
      });
      await await transactionalManager.getRepository(WfxImageUploadEntity).save(fileEntities);

      await transactionalManager.completeTransaction()
      return new CommonResponseModel(true, 3654, "Created Successfully")
    } catch (error) {
      await transactionalManager.releaseTransaction();
      return new CommonResponseModel(false, 6514, error.message)
    }
  }

  async getTechPackGridData(req: WFXStatusWiseReqDto): Promise<CommonResponseModel> {
    let status = [];
    if (req.role === WFXRolesEnum.HEAD_OF_TECHNICAL) {
      if (req.status === WFXStatusEnum.APPROVED) {
        status = [StatusApprovalsEnum.HEAD_OF_TECHNICAL_APPROVED, StatusApprovalsEnum.HEAD_OF_QUALITY_REJECTED, StatusApprovalsEnum.PENDING_WITH_HEAD_OF_QUALITY, StatusApprovalsEnum.HEAD_OF_QUALITY_APPROVED, StatusApprovalsEnum.PENDING_WITH_SAMPLE_ROOM_MANAGER, StatusApprovalsEnum.SAMPLE_ROOM_MANAGER_APPROVED, StatusApprovalsEnum.WARE_HOUSE_APPROVED, StatusApprovalsEnum.SAMPLE_ROOM_MANAGER_REJECTED, StatusApprovalsEnum.PENDING_WITH_WARE_HOUSE, StatusApprovalsEnum.WARE_HOUSE_REJECTED];
      }
      if (req.status === WFXStatusEnum.REJECTED) {
        status = [StatusApprovalsEnum.HEAD_OF_TECHNICAL_REJECTED]
      }
      if (req.status === WFXStatusEnum.PENDING_FOR_APPROVAL) {
        status = [StatusApprovalsEnum.PENDING_WITH_HEAD_OF_TECHNICAL]
      }
    }

    if (req.role === WFXRolesEnum.HEAD_OF_QUALITY) {
      if (req.status === WFXStatusEnum.APPROVED) {
        status = [StatusApprovalsEnum.HEAD_OF_QUALITY_APPROVED, StatusApprovalsEnum.PENDING_WITH_SAMPLE_ROOM_MANAGER, StatusApprovalsEnum.SAMPLE_ROOM_MANAGER_APPROVED, StatusApprovalsEnum.WARE_HOUSE_APPROVED, StatusApprovalsEnum.SAMPLE_ROOM_MANAGER_REJECTED, StatusApprovalsEnum.PENDING_WITH_WARE_HOUSE, StatusApprovalsEnum.WARE_HOUSE_REJECTED];
      }
      if (req.status === WFXStatusEnum.REJECTED) {
        status = [StatusApprovalsEnum.HEAD_OF_QUALITY_REJECTED]
      }
      if (req.status === WFXStatusEnum.PENDING_FOR_APPROVAL) {
        status = [StatusApprovalsEnum.PENDING_WITH_HEAD_OF_QUALITY]
      }
    }

    if (req.role === WFXRolesEnum.SAMPLE_ROOM_MANAGER) {
      if (req.status === WFXStatusEnum.APPROVED) {
        status = [StatusApprovalsEnum.SAMPLE_ROOM_MANAGER_APPROVED, StatusApprovalsEnum.WARE_HOUSE_APPROVED, StatusApprovalsEnum.PENDING_WITH_WARE_HOUSE, StatusApprovalsEnum.WARE_HOUSE_REJECTED];
      }

      if (req.status === WFXStatusEnum.REJECTED) {
        status = [StatusApprovalsEnum.SAMPLE_ROOM_MANAGER_REJECTED]
      }

      if (req.status === WFXStatusEnum.PENDING_FOR_APPROVAL) {
        status = [StatusApprovalsEnum.PENDING_WITH_SAMPLE_ROOM_MANAGER]
      }
    }

    if (req.role === WFXRolesEnum.WAREHOUSE_MANAGER) {
      if (req.status === WFXStatusEnum.APPROVED) {
        status = [StatusApprovalsEnum.WARE_HOUSE_APPROVED];
      }
      if (req.status === WFXStatusEnum.REJECTED) {
        status = [StatusApprovalsEnum.SAMPLE_ROOM_MANAGER_REJECTED]
      }
      if (req.status === WFXStatusEnum.PENDING_FOR_APPROVAL) {
        status = [StatusApprovalsEnum.PENDING_WITH_WARE_HOUSE]
      }
    }

    const data: any = await this.apparelAMrepo.find({ select: ['approvalStatus', 'role', 'bomNumber', 'id', 'created', 'status', 'techPack', 'department', 'buyer', 'remarks'], where: { approvalStatus: In([...status]), }, order: { createdAt: -1 } });
    if (data.length) {
      for (const rec of data) {
        const extractedFIlePath = await this.fileRepo.findOne({ where: { referenceFeature: ReferenceFeatureEnum.TECH_PACK, referenceFeatureId: rec.id } })
        rec.file = extractedFIlePath.fileName;
        const isVersionExist = await this.dataSource.getRepository(ApparelArticleMasterVersions).exist({ select: ['id'], where: { apparelArticleId: rec.id } })
        rec.isVersionExist = isVersionExist;
      }
      return new CommonResponseModel(true, 6155, "Data Retrieved Successfully", data)
    } else {
      return new CommonResponseModel(false, 9545, "No Data Found")
    }
  }

  async getAllTechPackData(req: WFXIdReqDto): Promise<CommonResponseModel> {
    if (!req.wfxId) {
      return new CommonResponseModel(false, 21655, "Please Provide Valid Tech Pack Id")
    }
    const data = await this.apparelAMrepo.findOne({ select: ['rawData'], where: { id: req.wfxId } });
    if (data) {
      const rawData = JSON.parse(data.rawData)
      rawData.articleApparelMaster[0].remarks = rawData.articleApparelMaster[0].remarks ? rawData.articleApparelMaster[0].remarks : ' '
      delete rawData.articleApparelMaster[0].role
      data.rawData = rawData
      return new CommonResponseModel(true, 55612, "Data Retrieved Successfully", data.rawData)
    } else {
      return new CommonResponseModel(false, 21655, "No Data Found")
    }
  }

  async getAllTechPckAndVersionsData(req: WFXAndVersionsIdReqDto): Promise<CommonResponseModel> {
    try {
      const originalReq = new WFXIdReqDto(req.originalId);
      const versionReq = new WFXIdReqDto(req.versionsId);
      const originalData = (await this.getAllTechPackData(originalReq)).data;
      const versionsData = (await this.getAllVersions(versionReq)).data;
      const versionsObj = {
        articleApparelMasterData: versionsData.articleApparelMaster,
        measurementChart2TDatasource: versionsData.measurement2TData,
        measurementChart6to12MonthsDatasource: versionsData.measurement6MonthsData,
        articleTextileFabricMatserDataSource: [versionsData.fabricData],
        articleTextileTrimMatserDataSource: [versionsData.trimData],
        id: req.versionsId
      };

      const originalObj = {
        apparelMatserData: originalData.articleApparelMaster,
        dataWith2T: originalData.measurement2TData,
        dataWithMonths: originalData.measurement6MonthsData,
        fabricData: [originalData.fabricData],
        trimData: [originalData.trimData],
        id: req.originalId
      };

      return new CommonResponseModel(true, 9554, "Data Retrieved Successfully", { originalData: originalObj, versionsData: versionsObj })
    } catch (error) {
      return new CommonResponseModel(false, 64516, error.message)
    }
  }

  async approveOriginalsRecords(req: ApprovalsReqDto): Promise<CommonResponseModel> {
    let updateStatus: StatusApprovalsEnum;
    let role: WFXRolesEnum;
    let internalMessage;
    if (req.role === WFXRolesEnum.HEAD_OF_TECHNICAL) {
      if (req.approvalStatus === StatusApprovalsEnum.PENDING_WITH_HEAD_OF_TECHNICAL) {
        updateStatus = StatusApprovalsEnum.HEAD_OF_TECHNICAL_APPROVED;
        role = req.role;
        internalMessage = "Approved Successfully"
      } else if (req.approvalStatus === StatusApprovalsEnum.HEAD_OF_TECHNICAL_APPROVED) {
        updateStatus = StatusApprovalsEnum.PENDING_WITH_HEAD_OF_QUALITY;
        role = WFXRolesEnum.HEAD_OF_QUALITY
        internalMessage = "Sent Successfully"
      } else if (req.approvalStatus === StatusApprovalsEnum.HEAD_OF_TECHNICAL_REJECTED) {
        updateStatus = StatusApprovalsEnum.HEAD_OF_TECHNICAL_REJECTED;
        role = req.role
        internalMessage = "Rejected Successfully"
      }
    } else if (req.role === WFXRolesEnum.HEAD_OF_QUALITY) {
      if (req.approvalStatus === StatusApprovalsEnum.PENDING_WITH_HEAD_OF_QUALITY) {
        updateStatus = StatusApprovalsEnum.HEAD_OF_QUALITY_APPROVED;
        role = req.role
        internalMessage = "Approved Successfully"
      } else if (req.approvalStatus === StatusApprovalsEnum.HEAD_OF_QUALITY_APPROVED) {
        updateStatus = StatusApprovalsEnum.PENDING_WITH_SAMPLE_ROOM_MANAGER;
        role = WFXRolesEnum.SAMPLE_ROOM_MANAGER
        internalMessage = "Sent Successfully"
      } else if (req.approvalStatus === StatusApprovalsEnum.HEAD_OF_QUALITY_REJECTED) {
        updateStatus = StatusApprovalsEnum.HEAD_OF_QUALITY_REJECTED;
        role = req.role
        internalMessage = "Rejected Successfully"

      }
    } else if (req.role === WFXRolesEnum.SAMPLE_ROOM_MANAGER) {
      if (req.approvalStatus === StatusApprovalsEnum.PENDING_WITH_SAMPLE_ROOM_MANAGER) {
        updateStatus = StatusApprovalsEnum.SAMPLE_ROOM_MANAGER_APPROVED
        role = req.role
        internalMessage = "Approved Successfully"
      } else if (req.approvalStatus === StatusApprovalsEnum.SAMPLE_ROOM_MANAGER_APPROVED) {
        updateStatus = StatusApprovalsEnum.PENDING_WITH_WARE_HOUSE;
        role = WFXRolesEnum.WAREHOUSE_MANAGER
        internalMessage = "Sent Successfully"
      } else if (req.approvalStatus === StatusApprovalsEnum.SAMPLE_ROOM_MANAGER_REJECTED) {
        updateStatus = StatusApprovalsEnum.SAMPLE_ROOM_MANAGER_REJECTED;
        role = req.role
        internalMessage = "Rejected Successfully"
      }
    } else if (req.role === WFXRolesEnum.WAREHOUSE_MANAGER) {
      if (req.approvalStatus === StatusApprovalsEnum.PENDING_WITH_WARE_HOUSE) {
        updateStatus = StatusApprovalsEnum.WARE_HOUSE_APPROVED;
        role = req.role;
        internalMessage = "Approved Successfully"
      } else if (req.approvalStatus === StatusApprovalsEnum.WARE_HOUSE_REJECTED) {
        updateStatus = StatusApprovalsEnum.WARE_HOUSE_REJECTED;
        role = req.role
        internalMessage = "Rejected Successfully"

      }
    }
    await this.apparelAMrepo.update({ id: req.id }, { approvalStatus: updateStatus })
    return new CommonResponseModel(true, 565678, internalMessage)
  }

  async deleteMeasurementDataCard(req: MeasurementDataCardDeleteReq): Promise<CommonResponseModel> {
    try {
      let query = `UPDATE measurement_data
                   SET status='DELETED'
                   WHERE id=${req.id}
                    `
      const result = await this.measurementRepo.query(query)
      if (result) {
        return new CommonResponseModel(true, 123, 'Item Deleted', result)
      }
    }
    catch (err) {
      throw err
    }
  }

  async deleteBuyerMaster(req: BuyerStatusReq): Promise<CommonResponseModel> {
    const transactionalManager = new GenericTransactionManager(this.dataSource)
    try {
      await transactionalManager.startTransaction()
      const existedFileName = await this.buyerRepo.findOne({ select: ['fileName'], where: { id: req.id } })
      await transactionalManager.getRepository(BuyerEntity).update({ id: req.id }, { status: UnitSevenStatusEnum.DELETED });
      await transactionalManager.completeTransaction()
      // const path = join(__dirname, '../../../../', 'image_files', existedFileName.fileName)
      // if (fs.existsSync(path)) {
      //   fs.unlinkSync(path)
      // }
      return new CommonResponseModel(true, 123, 'Buyer Deleted')
    }
    catch (err) {
      await transactionalManager.releaseTransaction()
      throw err

    }
  }


}